"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUserWithProfile = void 0;
const tslib_1 = require("tslib");
const createUser_1 = require("./createUser");
const profile_updateUser_1 = require("./profile.updateUser");
const helpers_1 = require("../../../src/lib/helpers");
const createUserWithProfile = userOptions => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
  try {
    let user = yield (0, createUser_1.create)(userOptions);
    if (userOptions.profile) {
      const pk = yield (0, helpers_1.decryptPGPKey)({
        account: user.did,
        encryptedPGPPrivateKey: user.encryptedPrivateKey,
        env: userOptions.env,
        signer: userOptions.signer
      });
      user = yield (0, profile_updateUser_1.profileUpdate)({
        account: user.did,
        env: userOptions.env,
        pgpPrivateKey: pk,
        profile: userOptions.profile
      });
    }
    return user;
  } catch (err) {
    throw new Error("[Push SDK] - Error in createUserWithProfile -: ".concat(err));
  }
});
exports.createUserWithProfile = createUserWithProfile;
//# sourceMappingURL=createUserWithProfile.js.map